export enum Roles {
  Admin = "ADMIN",
  Employee = "EMPLOYEE",
  SuperAdmin = "SUPERADMIN",
  Tenant = "TENANT",
  HR = "HR",
  Clerical = "CLERICAL",
}
